import { App } from '@capacitor/app';
import type { PluginListenerHandle } from '@capacitor/core';

type Unsubscribe = () => void;

export const subscribeAppStateChange = (
  listener: (isActive: boolean) => void,
): Unsubscribe => {
  let handle: Promise<PluginListenerHandle | undefined>;
  try {
    handle = App.addListener('appStateChange', ({ isActive }) =>
      listener(isActive),
    ).catch(() => undefined);
  } catch {
    return () => {};
  }
  return () => {
    void handle.then(resolved => resolved?.remove());
  };
};

export const subscribeVisibilityChange = (
  listener: (visibilityState: DocumentVisibilityState) => void,
): Unsubscribe => {
  const onChange = () => listener(document.visibilityState);
  document.addEventListener('visibilitychange', onChange);
  return () => document.removeEventListener('visibilitychange', onChange);
};

export const subscribeAppForeground = (
  onForeground: () => void,
  { isVisibilityIncluded = false }: { isVisibilityIncluded?: boolean } = {},
): Unsubscribe => {
  const unsubscribeVisibility = isVisibilityIncluded
    ? subscribeVisibilityChange(state => {
        if (state === 'visible') onForeground();
      })
    : undefined;
  const unsubscribeApp = subscribeAppStateChange(isActive => {
    if (isActive) onForeground();
  });
  return () => {
    unsubscribeVisibility?.();
    unsubscribeApp();
  };
};
